import { isAfter, isBefore, startOfDay, startOfToday } from 'date-fns';

/** Calendar-day comparison aligned with MariaDB CURRENT_DATE assignment filters. */
export function isAssignmentActiveOnCalendarDay(
    from: Date | null,
    to: Date | null,
    referenceDay: Date = startOfToday(),
): boolean {
    if (!from) {
        return false;
    }

    const day = startOfDay(referenceDay);
    const fromDay = startOfDay(from);

    if (isAfter(fromDay, day)) {
        return false;
    }

    if (!to) {
        return true;
    }

    return !isBefore(startOfDay(to), day);
}

export function isAssignmentFutureOnCalendarDay(
    from: Date | null,
    to: Date | null,
    referenceDay: Date = startOfToday(),
): boolean {
    if (!from) {
        return false;
    }

    const day = startOfDay(referenceDay);
    const fromDay = startOfDay(from);

    if (!isAfter(fromDay, day)) {
        return false;
    }

    return !to || isAfter(startOfDay(to), day);
}

export function isAssignmentPastOnCalendarDay(
    from: Date | null,
    to: Date | null,
    referenceDay: Date = startOfToday(),
): boolean {
    return !isAssignmentActiveOnCalendarDay(from, to, referenceDay)
        && !isAssignmentFutureOnCalendarDay(from, to, referenceDay);
}
